import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteCertificateMutation} from 'api';
import {useSnackbar} from 'notistack';

function CertificateDeleteIconButton({certificateId}) {
  const [deleteCertificate, deleteCertificateResult] = useDeleteCertificateMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteCertificate(certificateId).unwrap();
      enqueueSnackbar('Certificate deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error.status === 400 ? error.data?.details?.[0]?.message : undefined;
      enqueueSnackbar(message || `Error deleting Certificate`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete Certificate</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this Certificate?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteCertificateResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteCertificateResult.isLoading}
            color="error"
            endIcon={deleteCertificateResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteCertificateResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default CertificateDeleteIconButton;
